import React from 'react';

import { IconCaret2 } from '../..';

interface Props {
    isSorted?: boolean;
    isSortedDesc?: boolean;
    width?: number;
}

export const SortIcon = ({
    isSorted = false,
    isSortedDesc = false,
    width = 8,
}: Props): JSX.Element => {
    if (!isSorted) {
        // When the row is not sorted, we return this <span> exactly as styled here to keep vertical
        // spacing consistent in the header container. Otherwise, the header can be a different
        // height when there are no columns sorted vs. when at least one column is sorted, creating
        // layout shift.
        return (
            <span className="inline-block" style={{ width }}>
                &nbsp;
            </span>
        );
    }

    if (isSortedDesc) {
        return <IconCaret2 width={width} />;
    }

    return <IconCaret2 width={width} rotation={180} />;
};
